export default __webpack_public_path__ + "static/media/sunrise.cf07c915.mp3";